// UNICONNECT role names and per-section access policy.
//
// This MIRRORS the backend source of truth in backend/auth/roles.py and the per-router
// require_role(...) calls in backend/main.py. Keep the two in sync: this file only drives
// UX (nav hiding + route guards). The backend remains the real enforcement — a drift here
// just means an item is hidden-but-allowed or shown-but-403'd.

export const Role = {
  ADMINISTRATOR: 'UNICONNECT-ADMINISTRATOR',
  FULL_ACCESS: 'UNICONNECT-FULL-ACCESS',
  USER: 'UNICONNECT-USER',
  COMPETENCY: 'UNICONNECT-COMPETENCY',
  NETWORK: 'UNICONNECT-NETWORK',
  COMPANY: 'UNICONNECT-COMPANY',
  ALUMNI: 'UNICONNECT-ALUMNI',
  ACTIVITY: 'UNICONNECT-ACTIVITY',
} as const;

// ADMINISTRATOR and FULL_ACCESS are superset roles included in every gated section.
export const COMPANY_ROLES = [Role.COMPANY, Role.ADMINISTRATOR, Role.FULL_ACCESS] as const;
export const NETWORK_ROLES = [Role.NETWORK, Role.ADMINISTRATOR, Role.FULL_ACCESS] as const;
export const ALUMNI_ROLES = [Role.ALUMNI, Role.ADMINISTRATOR, Role.FULL_ACCESS] as const;
// Admin dashboard is ADMINISTRATOR-only (not FULL_ACCESS) — it exposes per-user
// activity (personal data). Mirrors require_role(ADMINISTRATOR) on the backend.
export const ADMIN_ROLES = [Role.ADMINISTRATOR] as const;

/** True when `required` is empty, or the user holds at least one of the required roles. */
export function hasAnyRole(
  userRoles: readonly string[] | null | undefined,
  required: readonly string[],
): boolean {
  if (required.length === 0) return true;
  const held = userRoles ?? [];
  return required.some((role) => held.includes(role));
}
